import { Link } from "react-router-dom";

type NagAlertProps = {
    title:string;
    shTitle:string;
    description: string;
    path:string;
};

const NagAlert = ({title,description, path, shTitle} : NagAlertProps) => {
    return <div className="card mt-4">
      <div className="cc-bg-theme-orange m-1 fs-5 rounded-1">
    <Link to={path} className="text-white px-3 py-2 d-block link-underline link-underline-opacity-0">
        <i className="bi bi-exclamation-triangle-fill float-end ps-2"></i>
      <p className="m-0"><span>{title} mangler!</span></p>
      </Link>
</div>
    <div className="card-body">
      <p>{description}</p>
      <div className="mb-0 d-md-flex justify-content-between align-items-center">
        <div>
          <Link to={path} className="btn btn-primary text-white">Legg til {shTitle}</Link>
        </div>
        <div className="mt-3 mt-md-0">
          <Link to={path} className="cc-icon-text-link text-muted"><i className="bi bi-box"></i> <span>Kjøpt produkt</span></Link>
        </div>
      </div>
    </div>
  </div>






    
    
}

export default NagAlert;